var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5831 0.000615383C31.6965 0.0138394 28.9402 0.260059 26.5152 0.689525C19.3704 1.95211 18.0732 4.59376 18.0732 9.46651V15.9016H34.9572V18.0464H11.7364C6.82965 18.0464 2.53246 20.996 1.18865 26.6067C-0.361711 33.038 -0.43035 37.0512 1.18865 43.7665C2.38889 48.7652 5.25536 52.3269 10.1621 52.3269H15.9675V44.6128C15.9675 39.0399 20.7892 34.1243 26.5152 34.1243H43.3796C48.0742 34.1243 51.8216 30.2591 51.8216 25.5444V9.46588C51.8216 4.89036 47.9614 1.45274 43.3796 0.688895C40.4785 0.206533 37.4697 -0.0132384 34.5831 0.000615383ZM25.4522 5.17562C27.1965 5.17562 28.6203 6.62334 28.6203 8.40292C28.6203 10.1762 27.1959 11.6107 25.4522 11.6107C23.7023 11.6107 22.2841 10.1768 22.2841 8.40292C22.2841 6.62334 23.7023 5.17562 25.4522 5.17562Z",
    fill: "url(#paint0_linear_1896_3604)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9264 18.0469V25.5443C53.9264 31.3572 48.9982 36.2494 43.3787 36.2494H26.5142C21.8946 36.2494 18.0723 40.2028 18.0723 44.8293V60.9066C18.0723 65.4827 22.0508 68.1742 26.5142 69.4865C31.8586 71.0583 36.9839 71.3423 43.3787 69.4865C47.6292 68.256 51.8206 65.7787 51.8206 60.9066V54.4722H34.9562V52.3274H60.2626C65.17 52.3274 66.998 48.9042 68.7046 43.767C70.4678 38.4786 70.3928 33.3918 68.7046 26.6072C67.4917 21.7225 65.1756 18.0469 60.2626 18.0469H53.9264ZM44.441 58.7618C46.191 58.7618 47.6091 60.1957 47.6091 61.9696C47.6091 63.7491 46.191 65.1969 44.441 65.1969C42.6967 65.1969 41.2729 63.7491 41.2729 61.9696C41.2729 60.1963 42.6973 58.7618 44.441 58.7618Z",
    fill: "url(#paint1_linear_1896_3604)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1896_3604",
    x1: -1.66522,
    y1: 2.01002,
    x2: 37.2691,
    y2: 35.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1896_3604",
    x1: 51.8773,
    y1: 55.8643,
    x2: 37.9086,
    y2: 36.2919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode4);
export default __webpack_public_path__ + "static/media/code4.5ce3d856c654bb5ab513663471d30c5b.svg";
export { ForwardRef as ReactComponent };